/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

